import React, { useEffect } from "react";
import Gradient from "./Gradient";
import blogGif from "../Assets/gif6.gif";
import "../Styles/Blog.css";

const Blog = () => {
  // Auto reload once on first load
  useEffect(() => {
    const hasReloaded = sessionStorage.getItem("blogHasReloaded");
    if (!hasReloaded) {
      sessionStorage.setItem("blogHasReloaded", "true");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    }
  }, []);

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scrolling
    });
  }, []);

  return (
    <div className="bg-b">
      {/* Gradient Background */}
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      >
        <Gradient
         gradientColors={["#FF0000", "#007BFF"]}
          angle={23}
          noise={0}
          blindCount={16}
          blindMinWidth={60}
          spotlightRadius={0.5}
          spotlightSoftness={1}
          spotlightOpacity={1}
          mouseDampening={2}
          distortAmount={0}
          shineDirection="left"
          mixBlendMode="lighten"
        />
      </div>

      {/* Content Section */}
      <div className="blog-container">
        {/* Left Side - Text */}
        <div className="blog-text">
          <h2>Our Blog</h2>
          <p>
            Explore our latest insights, tips, and updates from the world of
            digital solutions, web development, and marketing. Stay informed
            and inspired with our expert content.
          </p>
        </div>

        {/* Right Side - GIF */}
        <div className="blog-gif">
          <img src={blogGif} alt="Blog Animation" />
        </div>
      </div>
    </div>
  );
};

export default Blog;
